module.exports = __webpack_public_path__ + "static/media/service3.6c71d755.svg";